import React, { useEffect, useRef, useState } from 'react';
import { API_BASE_URL } from '../../utils/config';
import { Not } from './GirisKabugu';

/**
 * Robot doğrulama (ALTCHA, 03.11.2026). ATM'deki kurulumla aynı widget (public/altcha, MIT, kendi sunucumuzdan;
 * üçüncü tarafa veri gitmez). Görev /login/altcha'dan gelir ve tek kullanımlıktır: her gönderimden sonra üst bileşen
 * `key`'i değiştirip kutuyu yeniden kurar. Kullanıcı bulmaca çözmez; tarayıcı birkaç saniyede kendisi çözer.
 */
const KOK = `${process.env.PUBLIC_URL || ''}/altcha`;
let betikler = null;

const betikYukle = (src, modul) => new Promise((tamam, hata) => {
  const s = document.createElement('script');
  s.src = src;
  if (modul) s.type = 'module';
  s.onload = tamam;
  s.onerror = hata;
  document.head.appendChild(s);
});

// Önce Türkçe metinler (widget yüklenirken okunur), sonra widget — atm/giris.php ile aynı sıra.
const betikleriYukle = () => {
  if (!betikler) {
    betikler = betikYukle(`${KOK}/tr-3.4.1.js`).then(() => betikYukle(`${KOK}/altcha-3.4.1.min.js`, true))
      .catch((e) => { betikler = null; throw e; });
  }
  return betikler;
};

/** adres: görevin alındığı uç (giriş /login/altcha; şifre yenileme kendi ucunu kullanır). */
const AltchaKutusu = ({ onDogrulandi, adres = '/login/altcha' }) => {
  const kutu = useRef(null);
  const geriCagri = useRef(onDogrulandi);
  const [gorev, setGorev] = useState(null);
  const [hata, setHata] = useState(false);
  geriCagri.current = onDogrulandi;

  useEffect(() => {
    let iptal = false;
    geriCagri.current(null);
    Promise.all([
      betikleriYukle(),
      fetch(`${API_BASE_URL}${adres}`).then((y) => (y.ok ? y.json() : Promise.reject(y))),
    ]).then(([, g]) => { if (!iptal) setGorev(g); })
      .catch(() => { if (!iptal) setHata(true); });
    return () => { iptal = true; };
  }, [adres]);

  useEffect(() => {
    const el = kutu.current;
    if (!el) return undefined;
    const dogrulandi = (e) => geriCagri.current((e.detail && e.detail.payload) || null);
    el.addEventListener('verified', dogrulandi);
    return () => el.removeEventListener('verified', dogrulandi);
  }, [gorev]);

  if (hata) return <Not tur="hata">Robot doğrulaması yüklenemedi. Sayfayı yenileyip tekrar deneyin.</Not>;
  return (
    <div className="gk-robot">
      <span className="gk-robot-baslik">Güvenliğiniz için kısa bir robot doğrulaması yapılıyor.</span>
      {gorev ? (
        <altcha-widget ref={kutu} challenge={JSON.stringify(gorev)} language="tr" auto="onload"
          configuration='{"hideFooter":true}' />
      ) : (
        <div className="gk-robot-yukleniyor">Robot doğrulaması hazırlanıyor…</div>
      )}
    </div>
  );
};

export default AltchaKutusu;
